import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyNotification", "inviteCode"]

  disconnect() {
    if (this.notificationTimeout) clearTimeout(this.notificationTimeout)
  }

  copyInviteCode() {
    navigator.clipboard?.writeText?.(this.inviteCodeTarget.value)?.catch(() => {})
    this.copyNotificationTarget.classList.add("show")

    if (this.notificationTimeout) clearTimeout(this.notificationTimeout)
    this.notificationTimeout = setTimeout(() => this.copyNotificationTarget.classList.remove("show"), 5000)
  }

}
